const navigationSelector = '.jdgm-rev-snippet-widget__prev-btn, .jdgm-rev-snippet-widget__next-btn';
const reviewLinkSelector = '.jdgm-rev-snippet-card__full-review-link';
const hiddenProductLinkSelector = 'a.jdgm-full-rev__product-button';
const emptyReviewerImageSelector = '.jdgm-widget img:not([src]), .jdgm-widget img[src=""]';

function patchJudgeMeAccessibility() {
  document.querySelectorAll(navigationSelector).forEach((control) => {
    control.setAttribute('role', 'button');
    control.setAttribute('tabindex', '0');

    if (control.dataset.gsKeyboardReady === 'true') return;
    control.dataset.gsKeyboardReady = 'true';
    control.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      control.click();
    });
  });

  document.querySelectorAll(reviewLinkSelector).forEach((link) => {
    if (link.getAttribute('aria-label')) return;
    const reviewer = link.closest('.jdgm-rev-snippet-card')?.querySelector('.jdgm-rev-snippet-card__reviewer')?.textContent?.trim();
    link.setAttribute('aria-label', reviewer ? `Read full review by ${reviewer}` : 'Read full review');
  });

  document.querySelectorAll(hiddenProductLinkSelector).forEach((link) => {
    if (link.textContent.trim() || link.getBoundingClientRect().width > 0 || link.getBoundingClientRect().height > 0) return;
    link.setAttribute('tabindex', '-1');
    link.setAttribute('aria-hidden', 'true');
  });

  document.querySelectorAll(emptyReviewerImageSelector).forEach((image) => {
    image.hidden = true;
    image.setAttribute('aria-hidden', 'true');
    image.setAttribute('alt', '');
  });
}

let patchScheduled = false;
const observer = new MutationObserver(() => {
  if (patchScheduled) return;
  patchScheduled = true;
  requestAnimationFrame(() => {
    patchScheduled = false;
    patchJudgeMeAccessibility();
  });
});

patchJudgeMeAccessibility();
observer.observe(document.documentElement, { childList: true, subtree: true });
